module.exports = __webpack_public_path__ + "img/2.cbac400f.png";